import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationTestRunRequested.meta';

export type UseTrackAutomationTestRunRequestedParams = {
  automation_id: string;
};

export const useTrackAutomationTestRunRequested = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationTestRunRequested = useCallback(
    (params: UseTrackAutomationTestRunRequestedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationTestRunRequested };
};
